import React from 'react';
import { Footer } from '../Nav/Footer/Footer';
import { HomePage } from "../HomePage/HomePage";
import { NavBar } from '../Nav/NavBar/NavBar';



export const MainPage = () => {

    return (
        <div>
            <NavBar />
            <HomePage />
            <Footer />
        </div>

    );
}